// extracted by mini-css-extract-plugin
export default {"root__container":"Accordion_root__container__5U0rz","accordion__button":"Accordion_accordion__button__J6lwG"};